// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".site-speed-checkbox .ant-checkbox-checked .ant-checkbox-inner {\n  background-color: var(--background-color);\n  border-color: var(--border-color);\n}\n.site-speed-checkbox .ant-checkbox-inner {\n  border-color: var(--border-color);\n}\n", ""]);
// Exports
module.exports = exports;
